import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import Formsy from 'formsy-react';
import { withRouter } from 'react-router';
import closeIcon from '../../assets/images/newui/close.png'
import DGTextarea from 'components/FormControls/TextareaStepByStep/DGTextareaStepByStep';
import "./ActiveDriverModal.less"
import { Pagination, Dimmer, Loader, Segment, Header, Icon, Table, Button, Grid, Confirm, Modal } from 'semantic-ui-react'
import { getActiveSellerDrivers } from '../../services/Driver';
import { NavigationUrls } from '../../constants/NavigationUrls';

function ActiveDriverModal({ isOpen, onClose, onRowClick, header, selectedRequest, history}) {

  const [sellerDriver, setSellerDriver] = useState([])

  useEffect(() => {
    if (isOpen && selectedRequest) {
      loadData()
    }
  }, [isOpen,selectedRequest])

  const loadData = async () => {
    const scRequestID = selectedRequest?.scRequestID || 0
    let res = await getActiveSellerDrivers(scRequestID);
    if (res.resStatus == 200) {
      setSellerDriver(res.data)
    }
  }

  return (
    <Modal
      open={isOpen}
      closeOnDimmerClick={false}
      onClose={() => onClose()}
      className="active-driver-modal"
    >
      <Formsy>
        <div className="header">
          <div
            className="close-button"
            onClick={() => onClose()}
          >
            <img src={closeIcon}></img>
          </div>
          <div className="main-heading">{header || "Additional Details"} </div>
        </div>
        <div className="body">
          {
            selectedRequest?.dispatchRequest?.sellerDriver &&
            <>
              <div className='current-driver-container'>
                <span className='heading'>Currently Dispatched : </span>
                <span className='text'>   {selectedRequest?.dispatchRequest?.sellerDriver?.firstName + " " + selectedRequest?.dispatchRequest?.sellerDriver?.lastName} --
                  <Icon className='phone-icon' name='phone'></Icon> {selectedRequest?.dispatchRequest?.sellerDriver?.cellPhone}
                </span>
              </div>
            </>
          }

          <Table celled>

            {
              window.innerWidth < 768 ? <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>
                    <div className='email-invite-container'>
                      <div>
                        <Button onClick={() => {
                          history.push(NavigationUrls.INVITE_SELLER_DRIVER)
                        }}
                          className={"add-item-button"}>
                          + Add
                        </Button>
                      </div>
                    </div>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header> :
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Phone</Table.HeaderCell>
                    <Table.HeaderCell>
                      <div className='email-invite-container'>
                        <span>
                          Email
                        </span>

                        <div>
                          <Button onClick={() => {
                            history.push(NavigationUrls.INVITE_SELLER_DRIVER)
                          }}
                            className={"add-item-button"}>
                            + Add
                          </Button>
                        </div>
                      </div>
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
            }
            <Table.Body>
              {
                sellerDriver.map((driver) => {
                  return <>
                    <Table.Row onClick={() => onRowClick(driver)}>
                      <Table.Cell>{driver.firstName + " " + driver.lastName}</Table.Cell>
                      <Table.Cell>{driver.cellPhone}</Table.Cell>
                      <Table.Cell>{
                        <>
                          <span>
                            {driver.email}
                          </span>
                          <span style={{marginLeft : "20px", color:"green"}}>
                            {
                              selectedRequest?.dispatchRequest?.sellerDriver?.sellerDriverID == driver.sellerDriverID && 
                              <>
                                {"( Dispatched )"}
                              </>
                            }
                          </span>
                        </>
                      }</Table.Cell>
                    </Table.Row>
                  </>
                })
              }
            </Table.Body>
          </Table>
        </div>
      </Formsy>
    </Modal>
  );
}

export default withRouter(ActiveDriverModal);